import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revised-drawing',
  templateUrl: './revised-drawing.component.html',
  styleUrls: ['./revised-drawing.component.css']
})
export class RevisedDrawingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/revised-drawing/revised-drawing.component.ts